import { render, staticRenderFns } from "./TitleAndMessage.vue?vue&type=template&id=f6d85544&scoped=true&lang=pug&"
import script from "./TitleAndMessage.vue?vue&type=script&lang=ts&"
export * from "./TitleAndMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d85544",
  null
  
)

/* custom blocks */
import block0 from "./TitleAndMessage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports